const usersMock = [
  {
    'uuid': 'a4083655-3617-4d68-b1f8-813880e5fe37',
    'firstName': 'Talley',
    'lastName': 'Fowler'
  },
  {
    'uuid': 'bd453db5-7f5a-4d03-b43e-e63ffd7ee2fe',
    'firstName': 'Owens',
    'lastName': 'Lott'
  },
  {
    'uuid': '08ac17d1-8224-4bab-874d-301b71df3ec8',
    'firstName': 'Jacobson',
    'lastName': 'Vargas'
  },
  {
    'uuid': 'fc8f0ff4-c1e7-40ae-bc45-83bf3ac2bed6',
    'firstName': 'Roth',
    'lastName': 'Barlow'
  },
  {
    'uuid': '64b4772a-8557-4655-ba8f-b15c3931cf59',
    'firstName': 'Therese',
    'lastName': 'Bowman'
  },
  {
    'uuid': '0b219cb4-181f-4c35-90a1-0154bcad4033',
    'firstName': 'Angelica',
    'lastName': 'Massey'
  },
  {
    'uuid': 'b7a0967d-d2fb-4263-be32-abb2cd5350c3',
    'firstName': 'Mccarty',
    'lastName': 'Sims'
  },
  {
    'uuid': '15ffe32e-cc47-43b2-8975-bbd20ca0ce18',
    'firstName': 'Guerra',
    'lastName': 'Madden'
  },
  {
    'uuid': 'd704c8d9-d539-4db6-9c8b-94d095181f65',
    'firstName': 'Christensen',
    'lastName': 'Carlson'
  },
  {
    'uuid': '35a928e6-7e9e-438a-b316-861d85c2431e',
    'firstName': 'Reba',
    'lastName': 'Stevenson'
  },
  {
    'uuid': '7f5e84b9-dc5a-4023-babe-a5b79885a2b3',
    'firstName': 'Silva',
    'lastName': 'Hawkins'
  },
  {
    'uuid': '0576a354-a441-4cf2-bec3-8691030aac52',
    'firstName': 'Gena',
    'lastName': 'Mathis'
  },
  {
    'uuid': 'f23485c7-cc54-41df-9695-aebbd15b0136',
    'firstName': 'Golden',
    'lastName': 'Burgess'
  }
];

export class UserApiService {
  constructor(http) {
    this.endpoint = '/user/';
    this.http = http;
  }

  async get(id) {
    const response = await this.http.instance.get(this.endpoint + id);
    return response.data;
  }

  serializeList(users) {
    return users
      .filter(user => user.profile && user.profile.first_name && user.profile.last_name)
      .map(user => ({
        uuid: user.id,
        firstName: user.profile.first_name,
        lastName: user.profile.last_name,
        middleName: user.profile.middle_name,
        email: user.profile.email,
        phone: user.profile.phone,
        avatar: user.profile.avatar, // ? process.env.VUE_APP_API_URL + '/' + user.profile.avatar : null,
        endpoint: user.profile.endpoint
      }));
  }

  async getAll(search) {
    if (!search) {
      const response = await this.http.get(this.endpoint);
      return this.serializeList(response.data.items);
    }
    const response = await this.http.get(this.endpoint, { search });
    return this.serializeList(response.data.items);
  }

  async getProfile(id) {
    const  user  = await this.get(id);
    return this.serialize(user.profile);
  }

  async update(id, profile) {
    const body = this.deserialize(profile);
    const response = await this.http.instance.put(this.endpoint + id, body);
    return response.data;
  }

  async updateAvatar(id, avatar) { console.log(avatar);
  /*  const _avatar =
      process.env.NODE_ENV === 'production'
        ? avatar.slice(1)
        : avatar
        ? avatar.slice(process.env.VUE_APP_API_URL.length + 1)
        : avatar; */
    const { data } = await this.http.instance.put(this.endpoint + id, {
      avatar: avatar
    });
    return data;
  }

  deserialize(form) {
    const phone = form.phone ? '+7' + form.phone : '';
   /* const avatar =
      process.env.NODE_ENV === 'production'
        ? form.avatar
        : form.avatar
        ? form.avatar.slice(process.env.VUE_APP_API_URL.length + 1)
        : form.avatar; */
      const avatar = form.avatar;
    return {
      avatar,
      date_of_birth: form.birthDay,
      gender: form.gender,
      email: form.email,
      first_name: form.firstName,
      last_name: form.lastName,
      middle_name: form.middleName,
      phone
    };
  }

  serialize(data) {
    const phone = data.phone ? data.phone.slice(2) : '';
    const gender = data.gender ? data.gender : null;
    //const avatar = data.avatar ? process.env.VUE_APP_API_URL + '/' + data.avatar : null;
    const avatar = data.avatar;
    return {
      birthDay: data.date_of_birth,
      email: data.email,
      lastName: data.last_name,
      firstName: data.first_name,
      middleName: data.middle_name,
      avatar,
      gender,
      phone
    };
  }
}
